import React from 'react';
import './ImageStyleSheet.css';

function uml6() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/umass6.jpeg" className='img-view'/>
        </div>
    )
}

export default uml6
